import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
const DATE_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT_BBVA = 'YYYY-MM-DD';

export const dateToday = () => moment();

export const getDate = (stringDate, format = DATE_FORMAT_DEFAULT, strict = true) =>
  moment(stringDate, format, strict);

// Dates format
export const dateToString = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val).format(format) : '';

export const stringToDate = (val, format = DATE_FORMAT_DEFAULT) => moment(val, format);

export const dateToISO = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_ISO) : '';

export const changeFormatFromBBVA = val =>
  moment(val, DATE_FORMAT_BBVA).format(DATE_FORMAT_DEFAULT);

/**
 * Devuelve la edad en años cumplidos
 * @param {string} birthDate - Fecha de nacimiento (DD/MM/YYYY)
 * @returns {number}
 */
export const getAgeInYears = birthDate => {
  const today = moment().startOf('day');
  const birth = moment(birthDate, 'DD/MM/YYYY').startOf('day');
  let age = today.year() - birth.year();
  // Si aún no ha cumplido años este año, restamos 1
  if (today.isBefore(birth.clone().add(age, 'years'))) {
    age -= 1;
  }
  return age;
};

/**
 *
 * @param {string} birthDate
 * @param {string} licenseDate
 * @param {number} minAge
 * @returns number
 */
export const hasMinAgeAtLicenseDate = (birthDate, licenseDate, minAge) => {
  const birth = moment(birthDate, 'DD/MM/YYYY').startOf('day');
  const license = moment(licenseDate, 'DD/MM/YYYY').startOf('day');
  return birth.add(minAge, 'years').isSameOrBefore(license);
};

/**
 *
 * @param {string} licenseDate
 * @param {number} minYears
 * @returns boolean
 */
export const hasMinLicenseYears = (licenseDate, minYears) =>
  moment(licenseDate, 'DD/MM/YYYY')
    .add(minYears, 'years')
    .isSameOrBefore(moment());
